import { useQuery } from "@apollo/react-hooks";
import { QueryHookOptions } from "@apollo/react-hooks";
import SEASONS_DROPDOWN_QUERY from "@sellout/models/.dist/graphql/queries/seasonsDropdown.query";

interface ISeasonDropdown {
  _id: string;
  name: string;
  published: boolean;
  venueId?: string;
  seatingChartKey?: string;
  schedule?: {
    startsAt: number;
    endsAt: number;
  };
}

interface SeasonsDropdownData {
  seasons: ISeasonDropdown[];
}

interface SeasonsDropdownVars {
  query?: any;
}

type UseListSeasonsDropdown = {
  seasons: ISeasonDropdown[] | undefined;
  loading: boolean;
  error: any | undefined;
};

type UseListSeasonsDropdownHook = (params?: QueryHookOptions) => UseListSeasonsDropdown;

const useListSeasonsDropdownHook: UseListSeasonsDropdownHook = (params) => {
  const { data, loading, error } = useQuery<SeasonsDropdownData, SeasonsDropdownVars>(
    SEASONS_DROPDOWN_QUERY,
    {
      fetchPolicy: "cache-and-network",
      ...params
    }
  );

  return {
    seasons: data?.seasons,
    loading: loading,
    error: error,
  };
};

export default useListSeasonsDropdownHook;